/* Bookish / Skeinvale: show only the images of the selected garment color (data-mode="color") or necklace font (data-mode="font").
   Replaces two former inline scripts in layout/theme.liquid (Oct 3).
   Oct 11: the color of an image = the color value its alt text ENDS with (longest match first, so "Light Blue" beats "Blue").
   The old rule (text after the last "Gift ") broke titles like "... | Christmas Gift For Readers" -> every image hidden.
   Safety net: if no image matches the selected color/font, show all images instead of an empty gallery.
   Nov 2: Dawn sets the active slide AFTER its variant fetch (setActiveMedia), sometimes to media that is not in the main list
   -> no visible .is-active main = empty gallery on desktop (mobile slider unaffected). Re-run after Dawn's variantChange,
   always keep one visible active main, and hide thumbnails whose main image is not on the page (clicking them showed nothing).
   Nov 2 (2): no more jumping - setActiveMedia is redirected to the shown image (see patchGallery), filter runs once per change. */
(function () {
  var mode = (document.currentScript && document.currentScript.dataset.mode) || 'color';
  var FONT_RE = /font\s*0*(\d+)/i;
  var colorValues = [];

  function readColorValues(scope) {
    var seen = {};
    var vals = [];
    (scope || document).querySelectorAll('.swatch-input__input').forEach(function (input) {
      var v = (input.value || '').trim().toLowerCase();
      if (v && !seen[v]) {
        seen[v] = true;
        vals.push(v);
      }
    });
    return vals.sort(function (a, b) { return b.length - a.length; });
  }

  function extract(str) {
    str = str || '';
    if (mode === 'font') {
      var m = str.match(FONT_RE);
      return m ? 'font' + m[1] : null;
    }
    var alt = str.trim().toLowerCase();
    for (var i = 0; i < colorValues.length; i++) {
      var v = colorValues[i];
      if (alt === v || alt.slice(-(v.length + 1)) === ' ' + v) return v;
    }
    /* older rule: images of a color that is no longer offered stay hidden */
    var parts = alt.split('gift ');
    return parts.length > 1 ? parts[parts.length - 1].trim() : null;
  }

  function activeValue(scope) {
    if (mode !== 'font') {
      var checked = (scope || document).querySelector('.swatch-input__input:checked');
      return checked ? checked.value.trim().toLowerCase() : null;
    }
    var inputs = (scope || document).querySelectorAll(
      'variant-selects input:checked, variant-radios input:checked, .swatch-input__input:checked'
    );
    for (var i = 0; i < inputs.length; i++) {
      var f = extract(inputs[i].value);
      if (f) return f;
    }
    var selects = (scope || document).querySelectorAll('variant-selects select, variant-radios select');
    for (var j = 0; j < selects.length; j++) {
      var g = extract(selects[j].value);
      if (g) return g;
    }
    return null;
  }

  function altOf(el) {
    var img = el.querySelector('img');
    return extract(img ? img.alt : '');
  }

  function visible(el) { return el.style.display !== 'none'; }

  function filterGallery() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var scope = gallery.closest('product-info') || document;
    if (mode !== 'font') colorValues = readColorValues(scope);
    var active = activeValue(scope);
    if (!active) return;

    var thumbs = Array.from(gallery.querySelectorAll('.thumbnail-list__item'));
    var mains = Array.from(gallery.querySelectorAll('.product__media-item'));
    var mainIds = new Set(mains.map(function (el) { return el.dataset.mediaId; }));
    var all = thumbs.concat(mains);
    var known = new Set(all.map(altOf).filter(Boolean));
    var show = function (el) {
      var v = altOf(el);
      return v === active || !known.has(v);
    };
    var anyMatch = mains.some(show) || (!mains.length && thumbs.some(show));

    all.forEach(function (el) {
      var on = !anyMatch || show(el);
      if (on && mains.length && el.dataset.target && !mainIds.has(el.dataset.target)) on = false;
      el.style.display = on ? '' : 'none';
    });

    /* keep the active main if it is still shown (Dawn may have picked one), else the first shown one */
    var shownMains = mains.filter(visible);
    var shownThumbs = thumbs.filter(visible);
    var kept = shownMains.find(function (el) { return el.classList.contains('is-active'); });
    var main = kept || shownMains[0];
    var thumb = main && shownThumbs.find(function (el) { return el.dataset.target === main.dataset.mediaId; }) || shownThumbs[0];
    mains.forEach(function (el) { if (el.classList.contains('is-active') !== (el === main)) el.classList.toggle('is-active', el === main); });
    thumbs.forEach(function (el) { if (el.classList.contains('is-active') !== (el === thumb)) el.classList.toggle('is-active', el === thumb); });
    if (kept) return; /* nothing moved: no scroll / slider reset (repeated runs made the gallery jump) */
    if (main && main.parentElement) main.parentElement.scrollTo({ left: main.offsetLeft - main.parentElement.offsetLeft });
    gallery.querySelectorAll('slider-component').forEach(function (slider) {
      if (typeof slider.initPages === 'function') slider.initPages();
    });
  }

  /* Dawn's setActiveMedia falls back to the FIRST media (another color, hidden) when the variant image is not in the list
     -> one blank frame, then our re-run = the "jumping" gallery. Point it at the shown image of the selected color instead. */
  function patchGallery() {
    var MG = customElements.get('media-gallery');
    if (!MG || MG.prototype.bsPatched) return;
    var orig = MG.prototype.setActiveMedia;
    MG.prototype.bsPatched = true;
    MG.prototype.setActiveMedia = function (mediaId, prepend) {
      var el = this.querySelector('.product__media-item[data-media-id="' + mediaId + '"]');
      if (!el || el.style.display === 'none') {
        filterGallery();
        var cur = this.querySelector('.product__media-item.is-active');
        if (cur && cur.style.display !== 'none') {
          mediaId = cur.dataset.mediaId;
          prepend = false;
        }
      }
      return orig.call(this, mediaId, prepend);
    };
  }
  if (window.customElements) customElements.whenDefined('media-gallery').then(patchGallery);

  /* clicking a thumbnail shows the matching main image (even when images of other colors are hidden) */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.thumbnail-list__item');
    if (!thumb) return;
    var gallery = thumb.closest('media-gallery');
    var id = thumb.dataset.target;
    var main = gallery && id ? gallery.querySelector('[data-media-id="' + id + '"]') : null;
    if (!main) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    gallery.querySelectorAll('.thumbnail-list__item').forEach(function (t) { t.classList.remove('is-active'); });
    gallery.querySelectorAll('.product__media-item').forEach(function (m) { m.classList.remove('is-active'); });
    thumb.classList.add('is-active');
    main.classList.add('is-active');
    main.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  }, true);

  document.addEventListener('change', function (e) {
    if (!e.target.closest('variant-selects, variant-radios')) return;
    setTimeout(filterGallery, 0);
  });
  /* Dawn publishes variantChange after it has swapped the media and set its own active slide */
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined')
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(filterGallery, 0); });
  } catch (err) { /* no pubsub: the timeouts above still run */ }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', filterGallery);
  else filterGallery();
})();
